export default __webpack_public_path__ + "static/media/howto3.fcaa88c7.png";